import { makeVar } from '@apollo/client';
import { CHANNELS } from '@guuru/chat-common/src/Channels';
import { STEPS } from '../Steps';
import { Input } from '../constants/inputs';
import { ChatStep } from '../constants/chatSteps';

type Channel = keyof typeof CHANNELS;

/**
 * State containers aka reactive vars should be defined here.
 * note: don't call them directly in react components, good practices says
 * to use them inside custom hooks or call them through useReactiveVar hook.
 * */
const chatId = makeVar<string | null>(null);
const chatStep = makeVar<keyof typeof STEPS | null>(null);
const step = makeVar<ChatStep | null>(null);
const chatChannel = makeVar<Channel | null>(null);
const inputType = makeVar<Input | null>(null);
const isBotTypingVar = makeVar(false);
const isRunningStep = makeVar(false);
const connectionError = makeVar(false);
const feedbackSubmitted = makeVar(false);
const bottomSheetVisible = makeVar(false);
const isChatIframedVar = makeVar(window.self !== window.top);

export default {
  isBotTypingVar,
  chatId,
  chatStep,
  chatChannel,
  isRunningStep,
  connectionError,
  step,
  inputType,
  feedbackSubmitted,
  isChatIframedVar,
  bottomSheetVisible,
};

export type { Channel };
